import { useState, useRef, useEffect } from "react";
import DefaultAvatarLogo from "./DefaultAvatarLogo.js";

function MenuIcon({ type }) {
  if (type === "profile") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M20 21a8 8 0 0 0-16 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
        <circle cx="12" cy="8" r="4" stroke="currentColor" strokeWidth="1.8" />
      </svg>
    );
  }
  if (type === "watchlist") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M7 4h10a2 2 0 0 1 2 2v14l-7-3-7 3V6a2 2 0 0 1 2-2z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
      </svg>
    );
  }
  if (type === "lists") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M8 6h12M8 12h12M8 18h12M4 6h.01M4 12h.01M4 18h.01" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  if (type === "notifications") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M18 8a6 6 0 1 0-12 0c0 7-3 9-3 9h18s-3-2-3-9Z" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
        <path d="M13.73 21a2 2 0 0 1-3.46 0" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" />
      </svg>
    );
  }
  if (type === "settings") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M12 8a4 4 0 1 0 0 8 4 4 0 0 0 0-8Z" stroke="currentColor" strokeWidth="1.8" />
        <path d="M19.4 15a1.7 1.7 0 0 0 .34 1.87l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.7 1.7 0 0 0-1.87-.34 1.7 1.7 0 0 0-1.03 1.56V21a2 2 0 1 1-4 0v-.09a1.7 1.7 0 0 0-1.03-1.56 1.7 1.7 0 0 0-1.87.34l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06a1.7 1.7 0 0 0 .34-1.87A1.7 1.7 0 0 0 3 13.91H3a2 2 0 1 1 0-4h.09a1.7 1.7 0 0 0 1.56-1.03 1.7 1.7 0 0 0-.34-1.87l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06a1.7 1.7 0 0 0 1.87.34H9a1.7 1.7 0 0 0 1.03-1.56V3a2 2 0 1 1 4 0v.09a1.7 1.7 0 0 0 1.03 1.56 1.7 1.7 0 0 0 1.87-.34l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06a1.7 1.7 0 0 0-.34 1.87V9c0 .7.43 1.34 1.09 1.56H21a2 2 0 1 1 0 4h-.09a1.7 1.7 0 0 0-1.51.44Z" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (type === "admin") {
    return (
      <svg viewBox="0 0 24 24" fill="none" aria-hidden>
        <path d="M12 3l8 3v6c0 5-3.5 8.5-8 9-4.5-.5-8-4-8-9V6l8-3Z" stroke="currentColor" strokeWidth="1.8" strokeLinejoin="round" />
        <path d="M9.5 12.5l1.8 1.8 3.2-3.6" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 24 24" fill="none" aria-hidden>
      <path d="M9 21h6M12 17V3M5 7l7-4 7 4" stroke="currentColor" strokeWidth="1.8" strokeLinecap="round" strokeLinejoin="round" />
    </svg>
  );
}

function UserMenu({ userAvatar, isAdmin = false, unreadNotificationsCount = 0, onNavigate, onSignOut }) {
  const [isOpen, setIsOpen] = useState(false);
  const menuRef = useRef(null);
  const hasUnread = unreadNotificationsCount > 0;

  useEffect(() => {
    const handleClickOutside = (event) => {
      if (menuRef.current && !menuRef.current.contains(event.target)) {
        setIsOpen(false);
      }
    };

    if (isOpen) {
      document.addEventListener("mousedown", handleClickOutside);
    }

    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, [isOpen]);

  const handleMenuItemClick = (page) => {
    onNavigate(page);
    setIsOpen(false);
  };

  return (
    <div className="user-menu-container" ref={menuRef}>
      <div className="navbar_avatar_wrapper">
        <button
          className="navbar_avatar_button"
          onClick={() => setIsOpen(!isOpen)}
          title="Menu"
        >
          {userAvatar ? (
            <img
              src={userAvatar}
              alt="Profile"
              className="navbar_avatar"
              onError={(e) => {
                e.target.style.display = "none";
                e.target.nextSibling.style.display = "block";
              }}
            />
          ) : null}
          <div
            className="navbar_avatar_placeholder"
            style={{ display: userAvatar ? "none" : "block" }}
          >
            <DefaultAvatarLogo size={40} />
          </div>
        </button>
        {hasUnread && (
          <span className="navbar_notification_bell" title="You have notifications" aria-hidden>
            <svg width="16" height="16" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <path d="M18 8A6 6 0 0 0 6 8c0 7-3 9-3 9h18s-3-2-3-9" />
              <path d="M13.73 21a2 2 0 0 1-3.46 0" />
            </svg>
          </span>
        )}
      </div>

      {isOpen && (
        <div className="user-menu-dropdown">
          <button
            className="user-menu-item"
            onClick={() => handleMenuItemClick("profile")}
          >
            <span className="user-menu-icon"><MenuIcon type="profile" /></span>
            Profile
          </button>
          <button
            className="user-menu-item"
            onClick={() => handleMenuItemClick("watchlist")}
          >
            <span className="user-menu-icon"><MenuIcon type="watchlist" /></span>
            Watchlist
          </button>
          <button
            className="user-menu-item"
            onClick={() => handleMenuItemClick("lists")}
          >
            <span className="user-menu-icon"><MenuIcon type="lists" /></span>
            Lists
          </button>
          <button
            className="user-menu-item user-menu-item-with-badge"
            onClick={() => handleMenuItemClick("notifications")}
          >
            <span className="user-menu-icon"><MenuIcon type="notifications" /></span>
            Notifications
            {hasUnread && (
              <span className="user-menu-notification-badge">{unreadNotificationsCount > 99 ? "99+" : unreadNotificationsCount}</span>
            )}
          </button>
          <button
            className="user-menu-item"
            onClick={() => handleMenuItemClick("settings")}
          >
            <span className="user-menu-icon"><MenuIcon type="settings" /></span>
            Settings
          </button>
          {isAdmin && (
            <button
              className="user-menu-item user-menu-item-admin"
              onClick={() => handleMenuItemClick("admin")}
            >
              <span className="user-menu-icon"><MenuIcon type="admin" /></span>
              Admin panel
            </button>
          )}
          <div className="user-menu-divider"></div>
          <button
            className="user-menu-item user-menu-item-danger"
            onClick={onSignOut}
          >
            <span className="user-menu-icon"><MenuIcon type="signout" /></span>
            Sign Out
          </button>
        </div>
      )}
    </div>
  );
}

export default UserMenu;

